import { WALLET_STORAGE_KEY } from "@/config";
import type { Address } from "viem";
import { useEffect } from "react";
import { useENSName, useLocalStorage } from "@/hooks";
import { useAccount } from "wagmi";

export interface SavedWalletInfo {
    address: Address;
    ensName: string | null;
    lastUpdated: number;
}

export function useSavedWallet() {
    const [savedWallet, setSavedWallet, clearSavedWallet] = useLocalStorage<SavedWalletInfo | null>(
        WALLET_STORAGE_KEY,
        null,
    );
    const { address: currentAddress } = useAccount();
    const { ensName: currentENSName } = useENSName(currentAddress);

    // Update saved wallet when current wallet changes
    useEffect(() => {
        if (currentAddress) {
            if (!savedWallet || savedWallet.address !== currentAddress || savedWallet.ensName !== currentENSName) {
                setSavedWallet({
                    address: currentAddress,
                    ensName: currentENSName || null,
                    lastUpdated: Date.now(),
                });
            }
        }
    }, [currentAddress, currentENSName, savedWallet, setSavedWallet]);

    const clearWallet = () => {
        clearSavedWallet();
    };

    return {
        savedWallet,
        clearSavedWallet: clearWallet,
    };
}
